// eslint-disable-next-line import/no-anonymous-default-export
export default {
  formId: "phdForm",
  formField: {
    //Page 1
    photo: {
      name: "photo",
      label: "Choose your Photo",
      requiredErrorMsg: "Photo is required",
      file: {}
    },
    email: {
      name: "email",
      label: "Email*",
      requiredErrorMsg: "Email is required",
      invalidErrorMsg: "Email is not valid (e.g. Test@gmail.com)"
    },
    password: {
      name: "password",
      label: "Password*",
      requiredErrorMsg: "Password is required"
    },
    titleNameEng: {
      name: "titleNameEng",
      label: "Title's Name",
      requiredErrorMsg: "Title name is required"
    },
    firstNameEng: {
      name: "firstNameEng",
      label: "Name (In English)",
      requiredErrorMsg: "First name is required"
    },
    middleNameEng: {
      name: "middleNameEng",
      label: "Middle Name (In English)"
    },
    lastNameEng: {
      name: "lastNameEng",
      label: "Surname (In English)",
      requiredErrorMsg: "Last name is required"
    },
    titleNameThai: {
      name: "titleNameThai",
      label: "Title's Name (In Thai)",
      requiredErrorMsg: "Title name is required"
    },
    firstNameThai: {
      name: "firstNameThai",
      label: "Name (In Thai)",
      requiredErrorMsg: "First name is required"
    },
    middleNameThai: {
      name: "middleNameThai",
      label: "Middle Name (In Thai)"
    },
    lastNameThai: {
      name: "lastNameThai",
      label: "Surname (In Thai)",
      requiredErrorMsg: "Last name is required"
    },

    studentId: {
      name: "studentId",
      label: "Student ID",
      requiredErrorMsg: "Student ID is required"
    },

    gender: {
      name: "gender",
      label: "Gender",
      requiredErrorMsg: "Gender is required"
    },
    dateOfBirth: {
      name: "dateOfBirth",
      label: "Date of Birth*",
      requiredErrorMsg: "Date of Birth is required"
    },
    maritalStatus: {
      name: "maritalStatus",
      label: "Marital Status",
      requiredErrorMsg: "Marital Status is required"
    },
    bloodType: {
      name: "bloodType",
      label: "Blood Type",
      requiredErrorMsg: "Blood Type is required"
    },
    idCard: {
      name: "idCard",
      label: "ID card (Thai citizen) / Passport No.",
      requiredErrorMsg: "ID card / Passport No. is required"
    },
    nationality: {
      name: "nationality",
      label: "Nationality",
      requiredErrorMsg: "Nationality required"
    },

    /////////////////////////////////////////////////////////////////////////////
    //Page 2
    faculty: {
      name: "faculty",
      label: "Faculty / College / Institute",
      requiredErrorMsg: "Faculty / College / Institute is required"
    },
    major: {
      name: "major",
      label: "Major",
      requiredErrorMsg: "Major is required"
    },
    c2fScholarshipProgram: {
      name: "c2fScholarshipProgram",
      label: "C2F Scholarship Program",
      requiredErrorMsg: "C2F Scholarship Program is required"
    },
    mobileThai: {
      name: "mobileThai",
      label: "Mobile Number During Staying in Thai",
      requiredErrorMsg: "Mobile Number is required"
    },
    mobileCountry: {
      name: "mobileCountry",
      label: "Mobile Number at the Country of Residence",
      requiredErrorMsg: "Mobile Number is required"
    },
    mentor_id: {
      name: "mentor_id"
    },
    mentorName: {
      name: "mentorName",
      label: "Mentor's name",
      requiredErrorMsg: "Mentor's name is required"
    },
    mentorEmail: {
      name: "mentorEmail",
      label: "Mentor's email",
      requiredErrorMsg: "Mentor's email is required"
    },
    startFellowship: {
      name: "startFellowship",
      label: `Start Receiving Scholarship on 
      (Please type Semester/YYYY e.g. 1/2019)`,
      requiredErrorMsg: "Fellowship is required"
    },
    contractEnd: {
      name: "contractEnd",
      label: `Contract Ending on (Please type Semester/YYYY e.g. 2/2021)`,
      requiredErrorMsg: "Contract Ending is required"
    },
    researchArea: {
      name: "researchArea",
      label: "Research Area",
      requiredErrorMsg: "Research Area is required"
    },
    addressInThailand: {
      name: "addressInThailand",
      label: "Address in Thailand",
      requiredErrorMsg: "Address is required"
    },
    addressInTheCountryOfResidence: {
      name: "addressInTheCountryOfResidence",
      label: "Address in the Country of Residence",
      requiredErrorMsg: "Address is required"
    },

    /////////////////////////////////////////////////////////////////////////////
    //Page 3
    nameOfTheBachelorDegree: {
      name: "nameOfTheBachelorDegree",
      label: "Name of the Bachelor's Degree",
      requiredErrorMsg: "Bachelor Degree is required"
    },
    graduatedFromUniversityInstitute: {
      name: "graduatedFromUniversityInstitute",
      label: "Graduated from University/Institute",
      requiredErrorMsg: "Graduated is required"
    },
    countryOfTheBachelorUniversityInstitute: {
      name: "countryOfTheBachelorUniversityInstitute",
      label: "Country",
      requiredErrorMsg: "Country is required"
    },
    dateOfBachelorDegreeGraduation: {
      name: "dateOfBachelorDegreeGraduation",
      label: "Date of Bachelor Degree Graduation ",
      requiredErrorMsg: "Date is required"
    },
    nameOfMasterDegree: {
      name: "nameOfMasterDegree",
      label: `Name of Master's Degree (If you are a bachelor's degree holder applied to PhD Program, Please type "None")`,
      requiredErrorMsg: "Master Degree is required"
    },
    graduatedMasterFromUniversityInstitute: {
      name: "graduatedMasterFromUniversityInstitute",
      label: `Graduated from University/Institute (If you are a bachelor's degree holder applied to PhD Program, Please type "None")`,
      requiredErrorMsg: "Graduated Master  is required"
    },
    countryOfTheMasterUniversityInstitute: {
      name: "countryOfTheMasterUniversityInstitute",
      label: "Country",
      requiredErrorMsg: "Country is required"
    },

    ///////////////////////////////////////
    //Page4
    // Page 4
    workingExperienceList: {
      name: "workingExperienceList",
      subMenu: [
        {
          position: {
            name: "position",
            label: "Position",
            requiredErrorMsg: "Position is required"
          },
          companyOrganization: {
            name: "companyOrganization",
            label: "Company / Organization",
            requiredErrorMsg: "Company / Organization is required"
          },
          country: {
            name: "country",
            label: "Country",
            requiredErrorMsg: "Country is required"
          },
          started: {
            name: "started",
            label: "Started",
            requiredErrorMsg: "Started is required"
          },
          ended: {
            name: "ended",
            label: "Ended",
            requiredErrorMsg: "Ended is required"
          },
          stillInRole: {
            name: "stillInRole",
            label: "Still in role"
          }
        }
      ]
    },
    publication: {
      name: "publication",
      label: "Publication",
      requiredErrorMsg: "Publication is required"
    },
    awards: {
      name: "awards",
      label: "Awards",
      requiredErrorMsg: "Awards is required"
    },
    cvOrResume: {
      name: "cvOrResume",
      label: "CV or Resume",
      requiredErrorMsg: "CV or Resume is required",
      file: {}
    }
  }
};
